import request from '@/utils/request'

/**
 * 文件操作
 * 
*/
//获取文件数据   根据Id
export function getFileInfoById(params) {
  return request({
    url: '/catering/bizFile/findById/'+params,
    method: 'get',
  })
}

//获取文件数据   根据文件路径
export function getFileInfoByPath(params) {
  return request({
    url: '/catering/bizFile/findByFilePath/'+params,
    method: 'get',
  })
}


//添加文件数据信息
export function upload(data) {
  return request({
    url: '/catering/bizFile/upload',
    method: 'post',
    data,
  })
}

//将文件删除
export function delFile(data) {
  return request({
    url: '/catering/bizFile/deleteByIds',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
 * 菜单分类操作
 * 
*/
//获取到菜单分类列表数据
export function getFoodMenuPageList(data) {
  return request({
    url: '/catering/foodMenu/getList',
    method: 'post',
    data
  })
}

//获取到菜单分类列表数据 分页
export function getFoodMenuPagePage(data) {
  return request({
    url: '/catering/foodMenu/getPageList',
    method: 'post',
    data
  })
}

//获取分类数据   根据Id
export function getFoodMenuById(params) {
  return request({
    url: '/catering/foodMenu/findById/'+params,
    method: 'get',
  })
}

//获取分类数据   根据名称
export function getFoodMenuByName(params) {
  return request({
    url: '/catering/foodMenu/findByName/'+params,
    method: 'get',
  })
}

//添加分类数据
export function addFoodMenu(data) {
  return request({
    url: '/catering/foodMenu/saveInfo',
    method: 'post',
    data,
  })
}

//修改分类数据
export function foodMenuModify(data) {
  return request({
    url: '/catering/foodMenu/updateInfo',
    method: 'post',
    data,
  })
}


//将角色删除
export function foodMenuDel(data) {
  return request({
    url: '/catering/foodMenu/deleteByIds',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    },
  })
}



















